import { useCalendar } from '../contexts/CalendarContext';
import { useSession } from '../contexts/SessionContext';
import { deleteCookie } from '../utils/cookies';
import { getPossessionFields, fieldStateKey } from '../utils/dataFields';
import './CancelledScreen.css';

const CancelledScreen = () => {
  const { personalInfo, selectedLocation, selectedServices, selectedTimeSlot, schedule } = useSession();
  const { calendarId, fields } = useCalendar();
  const possessionLabel = fields?.possession_label || 'Details';
  const possessionSummary = getPossessionFields(fields)
    .map((f) => personalInfo?.[fieldStateKey(f)])
    .filter(Boolean)
    .join(' ');

  // Check if the appointment is in the past
  const isExpired = schedule?.appointment_naive && new Date(schedule.appointment_naive) < new Date();

  // Format the date and time for display
  const formatDateTime = (isoString) => {
    if (!isoString) return '';
    const date = new Date(isoString);
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    };
    return date.toLocaleString('en-US', options);
  };

  const onNewBooking = () => {
    // Clear session and reload
    const cookieName = `scheduler_session_${calendarId}`;
    deleteCookie(cookieName);

    const url = new URL(window.location.href);
    url.searchParams.delete('sessionId');
    window.location.href = url.toString();
  };

  return (
    <div className="cancelled-screen">
      <p className="cancelled-message">
        This appointment {isExpired ? 'has expired' : 'has been cancelled'} and is no longer active.
      </p>

      {schedule?.appointment_naive && (
        <div className="appointment-details">
          <h3>{isExpired ? 'Expired' : 'Cancelled'} Appointment Details</h3>
          <div className="detail-row">
            <span className="detail-label">Date & Time:</span>
            <span className="detail-value cancelled-datetime">{formatDateTime(schedule.appointment_naive)}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Location:</span>
            <span className="detail-value">{selectedLocation?.name}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Services:</span>
            <span className="detail-value">
              {selectedServices?.map(s => s.name).join(', ')}
            </span>
          </div>
          {possessionSummary && (
            <div className="detail-row">
              <span className="detail-label">{possessionLabel}:</span>
              <span className="detail-value">{possessionSummary}</span>
            </div>
          )}
        </div>
      )}

      <p className="cancelled-submessage">
        If you need to schedule a new appointment, you can start a new booking below.
      </p>
      <button
        className="new-booking-button"
        onClick={onNewBooking}
      >
        Start New Booking
      </button>
    </div>
  );
};

export default CancelledScreen;